import { ReferenceControl } from '../../types/types';

/**
 * Applies a click-time pre-resolved `control.filter` (see resolveControlFilter)
 * to the control handed over to FullscreenReference.
 *
 * `undefined` = nothing was resolved, keep the original filter.
 * `null` = the expression resolved to nothing, so the raw filter must be dropped
 * instead of leaking an unresolved template into the reference query.
 */
export const getControlWithResolvedFilter = (
  control: ReferenceControl,
  resolvedFilter?: Record<string, any> | null
): ReferenceControl => {
  if (resolvedFilter === undefined) {
    return control;
  }

  return { ...control, filter: resolvedFilter ?? undefined };
};
